import * as React from "react";
import { CallOutlined, EmailOutlined, WhatsApp, ContactMailOutlined } from "@mui/icons-material";
import { Container, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { colors } from "../../styles/constants";
import { EmailLink } from "../atoms/Link";
import { CallIcon } from "../atoms/HelpInfo";
import { useBrandingContext } from "@/contexts/BrandingContext";

export const NeedHelpBox2: React.FC = () => {
  return (
    <Stack rowGap={2}>
      <div>
        <b>Need help?</b>
      </div>

      <ContactingUs />
    </Stack>
  );
};

export const ContactingUs: React.FC = () => {
  const classes = useStyles();
  const { contactUsUrl, email, tel, whatsApp } = useBrandingContext();

  return (
    <div>
      <div className={classes.contactContainer}>
        <div className={classes.iconContainer}>
          <EmailOutlined fontSize="small" />
        </div>

        <div>
          Email us at{" "}
          <EmailLink to={`mailto:${email}`} target="_blank">
            {email}
          </EmailLink>
        </div>
      </div>

      <div className={classes.contactContainer}>
        <div className={classes.iconContainer}>
          <WhatsApp fontSize="small" color="success" />
        </div>

        <div> WhatsApp us at {whatsApp}</div>
      </div>

      <div className={classes.contactContainer}>
        <div className={classes.iconContainer}>
          <CallOutlined fontSize="small" />
        </div>

        <div>Call us at {tel} (9am to 5pm, Monday to Friday)</div>
      </div>

      <div className={classes.contactContainer}>
        <div className={classes.iconContainer}>
          <ContactMailOutlined fontSize="small" />
        </div>

        <div>
          Contact us via our{" "}
          <a href={contactUsUrl} target="_blank">
            contact form
          </a>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  contactContainer: { marginBottom: "0.3rem", display: "flex" },

  iconContainer: {
    paddingRight: "10px",
  },
});
